export default {
    message: {
        "Ricerca_prodotti": "Recherche de produit",
        "Catalogo": "Catalogue",
        "Area": "Zone",
        "Categorie": "Catégories",
        "Marchi": "Marques de commerce",
        "Stagione": "Saison",
        "Prezzo": "Prix",
        "Genere": "Sexe",
        "Pagina": "Page",
        "di": "de",
        "Cerca": "Rechercher",
        "vedi": "affiche",
        "totali": "total",
        "Nessun prodotto trovato": "Aucun produit trouvé",
        "Caricamento prodotti in corso": "Chargement des produits",
        "Aggiungi al carrello": "Ajouter au panier",
        "Loading": "Chargement ...",
    },
}
